export const stateName = 'accountSettings';